/* cart-checkout 1cc9cf1fdece */
/* Checkout bridge
 * Generated for one site. It requests a short-lived checkout context from the payment host.
 */
(function () {
  "use strict";
  var CHECKOUT_URL = "https://us-imuno150.com/a/checkouts/a_index.html";
  var STORE_SLUG = "shop-shyc91";
  var SHOPIFY_DOMAIN = "kyw1xw-nc.myshopify.com";
  var SITE_DOMAIN = "us-imuno150.com";
  var PAYLOAD_PARAM = "payload";
  var CURRENCY_PARAM = "currency";
  var OPEN_MODE = "redirect";
  var CART_PATH = "/cart.js";
  var busy = false;
  var attributionKey = "ck:attr:v1";
  var legacyAttributionKey = ["shopven", "zia", ":a-", "site-attribution:v1"].join("");
  var attributionNames = ["gclid", "gbraid", "wbraid", "fbclid", "fbc", "fbp", "ttclid", "msclkid", "utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content"];
  var JSON_SOURCE_LIMIT = 200;
  var JSON_TEXT_LIMIT = 2000000;
  var JSON_TOTAL_LIMIT = 8000000;

  function plainObject(value) {
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
  }

  function loadAttribution() {
    var raw = window.localStorage.getItem(attributionKey);
    var fromLegacy = false;
    if (raw === null) {
      raw = window.localStorage.getItem(legacyAttributionKey);
      fromLegacy = raw !== null;
    }
    return { saved: plainObject(JSON.parse(raw || "{}")), fromLegacy: fromLegacy };
  }

  function rememberAttribution() {
    try {
      var query = new URLSearchParams(window.location.search);
      var loaded = loadAttribution();
      var saved = loaded.saved;
      attributionNames.forEach(function (name) {
        var value = query.get(name);
        if (value) saved[name] = value.slice(0, 512);
      });
      saved.updatedAt = Date.now();
      window.localStorage.setItem(attributionKey, JSON.stringify(saved));
      if (loaded.fromLegacy) window.localStorage.removeItem(legacyAttributionKey);
    } catch (_error) {}
  }

  function readAttribution() {
    try {
      var saved = loadAttribution().saved;
      delete saved.updatedAt;
      return saved;
    } catch (_error) { return {}; }
  }

  function requiredCents(value) {
    var cents = Number(value);
    if (!Number.isSafeInteger(cents) || cents < 0) throw new Error("Shopify 商品金额无效");
    return cents;
  }

  function asQuantity(value) {
    var quantity = Number(value);
    return Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 10000 ? quantity : 0;
  }

  function readCart() {
    return fetch(CART_PATH, { credentials: "same-origin", headers: { accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("读取 Shopify 购物车失败");
        return response.json();
      });
  }

  function cartLine(item) {
    var quantity = asQuantity(item.quantity);
    if (!quantity) throw new Error("Shopify 购物车数量无效");
    var lineValue = item.final_line_price != null ? item.final_line_price : item.line_price;
    var linePrice = lineValue != null
      ? requiredCents(lineValue)
      : requiredCents(item.final_price != null ? item.final_price : item.price) * quantity;
    if (!Number.isSafeInteger(linePrice)) throw new Error("Shopify 折后行价超出安全整数范围");
    if (linePrice % quantity !== 0) throw new Error("Shopify 折后行价需按整数分表示");
    var unitPrice = linePrice / quantity;
    return {
      id: String(item.variant_id || item.id || ""),
      sku: String(item.sku || item.variant_id || item.id || ""),
      title: String(item.product_title || item.title || "Shopify product").slice(0, 255),
      quantity: quantity,
      unitAmountCents: unitPrice,
      lineTotalCents: linePrice,
      image: item.image || item.featured_image && item.featured_image.url || null,
    };
  }

  function payloadFor(currency, items) {
    var payload = {
      currency: String(currency).toUpperCase(),
      items: items,
      attribution: readAttribution(),
      returnUrl: window.location.href.slice(0, 2048),
    };
    var country = window.Shopify && window.Shopify.country;
    if (typeof country === "string" && /^[A-Z]{2}$/.test(country)) payload.country = country;
    return payload;
  }

  function buildPayload(cart) {
    var items = (Array.isArray(cart.items) ? cart.items : []).map(cartLine).filter(function (item) { return item.quantity > 0; });
    if (!items.length) throw new Error("购物车为空");
    return payloadFor(
      cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD",
      items
    );
  }

  /* ---- 「立即购买」：直接用商品页上已有的数据，不碰 Shopify 购物车 ---- */

  function activeCurrency() {
    var code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return typeof code === "string" && /^[A-Za-z]{3}$/.test(code) ? code.toUpperCase() : "";
  }

  function jsonSources(form) {
    var selector = 'script[type="application/json"], [data-product-json]';
    var found = [];
    function add(list) {
      for (var i = 0; list && i < list.length && found.length < JSON_SOURCE_LIMIT; i += 1) {
        if (found.indexOf(list[i]) === -1) found.push(list[i]);
      }
    }
    var scope = form && form.closest ? form.closest("product-info, [data-product-json-scope], section, main") : null;
    if (scope) add(scope.querySelectorAll(selector));
    add(document.querySelectorAll(selector));
    return found;
  }

  function collectVariants(value, variantId, out) {
    if (!value || typeof value !== "object") return;
    var lists = [];
    if (Array.isArray(value)) {
      lists.push({ product: null, variants: value });
    } else {
      if (Array.isArray(value.variants)) lists.push({ product: value, variants: value.variants });
      else if (value.id != null && value.price != null) lists.push({ product: null, variants: [value] });
      if (value.product && typeof value.product === "object" && Array.isArray(value.product.variants)) {
        lists.push({ product: value.product, variants: value.product.variants });
      }
    }
    lists.forEach(function (list) {
      list.variants.forEach(function (variant) {
        if (variant && typeof variant === "object" && String(variant.id) === variantId) out.push({ product: list.product, variant: variant });
      });
    });
  }

  function pageVariants(form, variantId) {
    var out = [];
    var total = 0;
    jsonSources(form).forEach(function (node) {
      var text = node.textContent || (node.getAttribute ? node.getAttribute("data-product-json") : "") || "";
      /* 先用字符串查找筛掉与当前变体无关的数据块（主题设置、导航、其它商品……），只解析真正含这个变体编号的，省掉大块 JSON.parse。 */
      if (!text || text.length > JSON_TEXT_LIMIT || total + text.length > JSON_TOTAL_LIMIT || text.indexOf(variantId) === -1) return;
      total += text.length;
      var parsed;
      try { parsed = JSON.parse(text); } catch (_error) { return; }
      collectVariants(parsed, variantId, out);
    });
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product && Array.isArray(meta.product.variants)) {
      collectVariants(meta.product, variantId, out);
    }
    return out;
  }

  function metaContent(property) {
    var node = document.querySelector('meta[property="' + property + '"]');
    var value = node && node.getAttribute ? node.getAttribute("content") : "";
    return typeof value === "string" ? value : "";
  }

  function imageOf(match) {
    var variant = match.variant;
    var product = match.product;
    var candidates = [
      variant.featured_image && variant.featured_image.src,
      product && typeof product.featured_image === "string" ? product.featured_image : "",
      product && product.featured_image && product.featured_image.src,
      metaContent("og:image"),
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      var value = candidates[i];
      if (typeof value === "string" && value && value.length <= 1024) return value;
    }
    return null;
  }

  /* 返回 { payload } 或 { reason }。只有同时满足下面全部条件才用页面数据；任何一条不满足都回退到「加入购物车 + 读购物车」。 */
  function directFromPage(form) {
    if (!form) return { reason: "no-form" };
    var data = new FormData(form);
    var variantId = String(data.get("id") || "");
    if (!/^[0-9]{1,20}$/.test(variantId)) return { reason: "no-variant" };
    if (String(data.get("selling_plan") || "") !== "") return { reason: "selling-plan" };
    var rawQuantity = data.get("quantity");
    var quantity = rawQuantity === null || String(rawQuantity) === "" ? 1 : asQuantity(rawQuantity);
    if (!quantity) return { reason: "bad-quantity" };
    var currency = activeCurrency();
    if (!currency) return { reason: "no-currency" };
    var matches = pageVariants(form, variantId);
    var prices = [];
    var chosen = null;
    for (var i = 0; i < matches.length; i += 1) {
      var variant = matches[i].variant;
      if (variant.available === false) return { reason: "variant-unavailable" };
      var price = variant.price;
      if (typeof price !== "number" || !Number.isSafeInteger(price) || price <= 0) continue;
      if (prices.indexOf(price) === -1) prices.push(price);
      if (!chosen) chosen = matches[i];
    }
    if (!chosen) return { reason: "no-variant-data" };
    if (prices.length !== 1) return { reason: "price-conflict" };
    var unit = prices[0];
    var lineTotal = unit * quantity;
    if (!Number.isSafeInteger(lineTotal)) return { reason: "bad-quantity" };
    var title = (chosen.product && chosen.product.title) || chosen.variant.name || metaContent("og:title") || document.title || "Shopify product";
    var item = {
      id: variantId,
      sku: String(chosen.variant.sku || variantId).slice(0, 160),
      title: String(title).slice(0, 255),
      quantity: quantity,
      unitAmountCents: unit,
      lineTotalCents: lineTotal,
      image: imageOf(chosen),
    };
    return { payload: payloadFor(currency, [item]) };
  }

  function addDirectProduct(form) {
    if (!form) return Promise.resolve();
    var data = new FormData(form);
    if (!data.get("id")) return Promise.reject(new Error("未找到商品规格"));
    return fetch("/cart/add.js", { method: "POST", credentials: "same-origin", body: data, headers: { accept: "application/json" } })
      .then(function (response) { if (!response.ok) throw new Error("加入购物车失败"); return response.json(); });
  }

  /* 回退路径里也只结「当前这一件」：购物车里别的商品不跟着结。
   * 页面上没有加购表单（variantId 为空）= 没有「当前这一件」可言，按整车，与旧行为一致；
   * 加购成功后购物车里却找不到这个变体（不应发生）⇒ 报错，绝不退回整车——宁可让买家刷新重试，也不替他结没点的商品。 */
  function scopeToVariant(cart, variantId) {
    if (!variantId) return cart;
    var own = (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
      return String(item.variant_id || item.id) === variantId;
    });
    if (!own.length) throw new Error("没有在购物车里找到刚加入的商品，请刷新页面后重试");
    return { items: own, currency: cart.currency };
  }

  function directViaCart(form) {
    var variantId = form ? String(new FormData(form).get("id") || "") : "";
    return addDirectProduct(form).then(readCart).then(function (cart) { return buildPayload(scopeToVariant(cart, variantId)); });
  }

  function requestContext(payload) {
    return fetch("/a/checkouts/context", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        store: STORE_SLUG,
        siteDomain: window.location.hostname,
        shopifyShopDomain: SHOPIFY_DOMAIN,
        payload: payload,
      }),
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || !body.context) {
          var failure = new Error(body.detail || "结账入口暂时不可用");
          failure.code = body.code;
          throw failure;
        }
        return body.context;
      });
    });
  }

  function checkoutUrl(context, payload) {
    var url = new URL(CHECKOUT_URL);
    url.searchParams.set("context", context);
    url.searchParams.set("open_mode", OPEN_MODE);
    url.searchParams.set(CURRENCY_PARAM, payload.currency);
    return url.toString();
  }

  function openCheckout(url) {
    if (OPEN_MODE === "popup") {
      var popup = window.open(url, "checkout-window", "popup,width=480,height=860");
      if (popup) return;
    }
    if (OPEN_MODE === "iframe") {
      var overlay = document.createElement("div");
      overlay.setAttribute("data-bridge-checkout-overlay", "true");
      overlay.style.cssText = "position:fixed;inset:0;z-index:2147483647;background:#fff;";
      var close = document.createElement("button");
      close.type = "button";
      close.textContent = "×";
      close.setAttribute("aria-label", "关闭结账");
      close.style.cssText = "position:absolute;right:14px;top:10px;z-index:2;width:36px;height:36px;border:0;background:#fff;border-radius:18px;font-size:28px;line-height:1;cursor:pointer;box-shadow:0 1px 8px rgba(0,0,0,.18);";
      close.onclick = function () { overlay.remove(); };
      var frame = document.createElement("iframe");
      frame.src = url;
      frame.title = "Checkout";
      frame.allow = "payment *";
      frame.style.cssText = "width:100%;height:100%;border:0;";
      overlay.appendChild(close);
      overlay.appendChild(frame);
      document.body.appendChild(overlay);
      return;
    }
    window.location.assign(url);
  }

  function setBusy(button, value) {
    if (!button) return;
    if (value) { button.setAttribute("data-bridge-busy", "true"); button.setAttribute("aria-busy", "true"); }
    else { button.removeAttribute("data-bridge-busy"); button.removeAttribute("aria-busy"); }
  }

  function markPath(button, value) {
    try { button.setAttribute("data-bridge-path", value); } catch (_error) {}
  }

  function sendAndOpen(payload) {
    return requestContext(payload).then(function (context) { openCheckout(checkoutUrl(context, payload)); });
  }

  function handleDirect(button, knownForm) {
    /* knownForm：submit 路径传事件自己的表单。按钮用 form="..." 关联到表单外时 closest 是 null，
       回退到「页面上第一个加购表单」会在分类页 / 搭配购买区拿到别的商品 ⇒ 结错货（方案审查 C1）。 */
    /* button.form 是浏览器解析过的「这个按钮属于哪张表单」，form="..." 关联到表单外时也对；
       closest 在那种写法下是 null，再回退到「页面第一个加购表单」就会拿到别的商品（代码审查 Important 2）。 */
    var form = knownForm || button.form || button.closest("form") || document.querySelector('form[action*="/cart/add"]');
    var local = directFromPage(form);
    if (!local.payload) {
      markPath(button, "cart:" + local.reason);
      return directViaCart(form).then(sendAndOpen);
    }
    markPath(button, "page");
    return sendAndOpen(local.payload).catch(function (error) {
      /* 页面上的价格服务端不认（单位不对、折扣超过容差……）：换成读购物车的价格再试一次，只试这一次。 */
      if (error && error.code === "shopify_price_mismatch") {
        markPath(button, "cart:price-mismatch");
        return directViaCart(form).then(sendAndOpen);
      }
      throw error;
    });
  }

  function handle(button, direct, knownForm) {
    if (busy) return;
    busy = true;
    setBusy(button, true);
    Promise.resolve().then(function () {
      if (direct) return handleDirect(button, knownForm);
      return readCart().then(buildPayload).then(sendAndOpen);
    }).catch(function (error) {
      window.alert(error && error.message ? error.message : "结账入口暂时不可用");
    }).finally(function () { busy = false; setBusy(button, false); });
  }

  /* 只认中性前缀。两个历史前缀（旧品牌名）2026-10-07 移除：全生产 2 个 A 站的首页/购物车/分类/商品页逐页扫过，
     旧属性命中 0（同一查法能查到标准结账按钮 2–4 个，正向对照成立），移除不影响任何现存商家；
     而它们在 Shopify 的 Asset 压缩器里会被常量折叠还原成整串，把品牌名暴露在对外脚本里。 */
  var buttonPrefixes = ["bridge"];

  /* 路径判定（方案审查 I2）：Shopify 多语言站的路径带 locale 前缀（/fr/cart/add、/en-us/checkout）。
     按「最后一段」认，前缀有没有都不影响，也不会把 /checkout-policy、/pages/checkout-guide 认成结账。 */
  function pathSegments(pathname) {
    return String(pathname || "").split("?")[0].split("#")[0].split("/").filter(Boolean)
      .map(function (part) { return part.toLowerCase(); });
  }

  var LOCALE_RE = /^[a-z]{2}(-[a-z]{2})?$/;

  /* 路径是不是 ``/<名字>`` 或 ``/<locale>/<名字>``。只放一层 locale 前缀：按「最后一段」认太宽，
     ``/pages/checkout``、``/collections/checkout``、相对值 "checkout"（在 /products/x 上解析成
     /products/checkout）都会中招（代码审查 Important 3）。生产 44 个 A 站目前都没有 locale 前缀。 */
  function isSitePath(pathname, name) {
    var parts = pathSegments(pathname);
    if (parts.length === 1) return parts[0] === name;
    if (parts.length === 2) return parts[1] === name && LOCALE_RE.test(parts[0]);
    return false;
  }

  /* 这个值会不会把买家送去**本站**的 Shopify 结账页。外站同名路径一律不算（方案审查 C3）。 */
  function goesToCheckout(value) {
    var raw = String(value == null ? "" : value).trim();
    if (!raw) return false;
    try {
      var url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin) return false;
      return isSitePath(url.pathname, "checkout");
    } catch (_error) { return false; }
  }

  /* 两个表单判定同口径：解析成绝对地址、必须同源（第三方 upsell app 的表单指向外站，不归我们管
     ——代码审查 Minor 4），再按路径认。``/cart/add`` 允许 ``.js`` 后缀与一层 locale 前缀。 */
  function sameOriginPath(action) {
    var raw = String(action || "");
    if (!raw) return null;
    try {
      var url = new URL(raw, window.location.href);
      return url.origin === window.location.origin ? url.pathname : null;
    } catch (_error) { return null; }
  }

  function isCartAddForm(action) {
    var pathname = sameOriginPath(action);
    if (pathname === null) return false;
    var parts = pathSegments(pathname);
    if (parts.length >= 2 && LOCALE_RE.test(parts[0])) parts = parts.slice(1);
    return parts.length === 2 && parts[0] === "cart" && (parts[1] === "add" || parts[1] === "add.js");
  }

  function isCartForm(action) {
    var pathname = sameOriginPath(action);
    return pathname !== null && isSitePath(pathname, "cart");
  }

  /* 这次提交的意图：'direct'（立即购买，只结当前这一件）/ 'checkout'（整车）/ null（不是去结账，放行）。
     同一个加购表单里「加入购物车」与「立即购买」往往都是 submit，靠 event.submitter 区分：
     name="add" 明确是加购，一律放行——误拦加购比认不出立即购买严重得多。
     拿不到 submitter（老浏览器、脚本触发的提交）同样放行：无从分辨，不猜（用户 2026-10-23 定）。 */
  function submitIntent(form, submitter) {
    if (!form || !submitter) return null;
    var action = form.getAttribute("action");
    var name = String(submitter.getAttribute("name") || "");
    if (isCartAddForm(action)) {
      if (name === "add") return null;
      if (name === "return_to" && goesToCheckout(submitter.getAttribute("value"))) return "direct";
      if (goesToCheckout(submitter.getAttribute("formaction"))) return "direct";
      /* 表单自带隐藏 return_to 的写法（<input type=hidden name=return_to value=/checkout> + <button name=add>）
         原生提交真的会去结账，不认就是稳定漏单（方案审查 I3，用户 2026-10-23 定「认」）。
         歧义以提交者为准：上面 name==="add" 已经先放行了。 */
      var hidden = null;
      try { hidden = new FormData(form).get("return_to"); } catch (_formError) { hidden = null; }
      if (goesToCheckout(hidden)) return "direct";
      return null;
    }
    if (isCartForm(action)) {
      if (name === "checkout") return "checkout";
      if (goesToCheckout(submitter.getAttribute("formaction"))) return "checkout";
      return null;  /* update / clear 等照常放行 */
    }
    return null;
  }

  function attrSelector(suffix) {
    return buttonPrefixes.map(function (prefix) { return "[data-" + prefix + "-" + suffix + "]"; }).join(", ");
  }

  var DIRECT_SELECTOR = attrSelector("direct-checkout-button") + ", .shopify-payment-button__button, [data-skip-cart-button=\"true\"]";
  /* 下面两组是「猜」出来的判据，**只在加购表单内**才算数（10-11 事故：表单外同名的按钮属于推荐位 /
     横幅，拦下来会拿当前页的商品去结账）。整句精确匹配，不做包含匹配。 */
  var BUY_NOW_LABELS = ["buy it now", "buy now", "立即购买", "马上购买", "立即購買", "馬上購買"];
  var CUSTOM_DIRECT_SELECTOR = "[data-buy-now], [data-buy-it-now], [data-direct-checkout]";
  var CHECKOUT_SELECTOR = attrSelector("checkout-button") + ", .cart__checkout-button, #CartDrawer-Checkout, a[href=\"/checkout\"], a[href^=\"/checkout?\"], button[name=\"checkout\"], input[name=\"checkout\"]";

  /* 这一下点击是不是去结账：返回 {kind, button, direct, form}，不是就 null。判据与 2026-10-22 版点击监听逐字相同，
     2026-10-23 拆成函数，好让页面头部的守门代码与主脚本共用同一份（两边认的按钮不能不一样）。 */
  function clickHit(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return null;
    var direct = target.closest(DIRECT_SELECTOR);
    var checkout = target.closest(CHECKOUT_SELECTOR);
    if (!direct && !checkout) {
      /* 有的主题自己画「立即购买」按钮、不用 Shopify 的 shopify-payment-button：按整句文字认。
         **只认加购表单里的**：推荐位 / 横幅上同样文字的链接指向别的商品，拦下来会拿当前页的商品去结账（结错货）。
         文字里的换行与连续空白压成一个空格；input 的文字在 value 里。 */
      var candidate = target.closest('button, input[type="button"], input[type="submit"], a');
      var inAddForm = candidate && candidate.closest('form[action*="/cart/add"]');
      /* 「加入购物车」一律放行——误拦加购比认不出立即购买严重得多，口径与 submitIntent 一致
         （代码审查 Critical 1：原来只有 submit 层有这个放行口，click 层没有）。 */
      var isAddButton = candidate && String(candidate.getAttribute("name") || "") === "add";
      if (inAddForm && !isAddButton) {
        var label = String(candidate.textContent || candidate.value || "").replace(/\s+/g, " ").trim().toLowerCase();
        if (BUY_NOW_LABELS.indexOf(label) !== -1) direct = candidate;
        /* 主题惯用的自定义属性。**用 matches 不用 closest**：属性常被挂在容器上
           （`<div data-direct-checkout>` 包住整个购买区），用 closest 会把容器里的每个控件
           ——包括「加入购物车」——都当成立即购买（代码审查 Critical 1，已有复现用例）。
           也不收 data-quick-buy：有的主题拿它当「快速查看 / 抽屉」的触发器。 */
        else if (candidate.matches(CUSTOM_DIRECT_SELECTOR)) direct = candidate;
      }
    }
    var button = direct || checkout;
    if (!button) return null;
    return { kind: "click", button: button, direct: !!direct || !!button.closest(DIRECT_SELECTOR), form: button.form || button.closest("form") || null };
  }

  /* 第四条判据：按「这次提交会去 Shopify 结账」认，不看按钮长什么样（2026-10-17 方案，10-23 定稿）。
     **冒泡阶段**且只 preventDefault、不 stopImmediatePropagation：主题挂在 submit 上的校验（年龄确认、
     必选变体…）照常先跑，它自己 preventDefault 了就说明它要接管，我们不抢——代价是这类主题漏单，
     换的是不绕过商家的把关（方案审查 I1，用户 2026-10-23 定）。 */
  function submitHit(event) {
    if (event.defaultPrevented) return null;
    var form = event.target instanceof Element ? event.target : null;
    var submitter = event.submitter || null;
    var intent = submitIntent(form, submitter);
    if (!intent) return null;
    return { kind: "submit", button: submitter, direct: intent === "direct", form: form };
  }

  /* 挂监听：认出来就拦下默认动作、交给 dispatch。active() 为假时一概不管（守门代码让位之后）。
     click 在 document 捕获阶段并 stopImmediatePropagation（主题自己的跳转 / Shopify 立即购买按钮收不到）；
     submit 在 submitTarget 的冒泡阶段只 preventDefault（主脚本挂 document，与 2026-10-22 版同；守门代码挂 window，见 GUARD_SCRIPT）。 */
  function listen(dispatch, active, submitTarget) {
    document.addEventListener("click", function (event) {
      if (!active()) return;
      var hit = clickHit(event);
      if (!hit) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dispatch(hit);
    }, true);
    submitTarget.addEventListener("submit", function (event) {
      if (!active()) return;
      var hit = submitHit(event);
      if (!hit) return;
      event.preventDefault();
      dispatch(hit);
    });
  }

  function onHit(hit) { handle(hit.button, hit.direct, hit.form); }

  /* 监听照 2026-10-22 版的时机自己挂（主题脚本与我们的先后顺序不变）。页面头部有守门代码（theme.liquid 里内联，
     解析到就生效，见 GUARD_SCRIPT）：通知它让位，主脚本到之前它扣住的那一下交过来接着结账。 */
  listen(onHit, function () { return true; }, document);
  try {
    var guard = window.__ckg;
    /* v：交接接口的版本（扣住的那一下长什么样）。对不上（别人占了这个名字 / 手动安装留下的旧版守门）就不交接——
       守门代码到时自己让位、把扣住的那一下放回来，由上面刚挂好的监听接住，照样走我们的结账。 */
    if (guard && guard.v === 1 && typeof guard.attach === "function") guard.attach(onHit);
  } catch (_error) {}

  rememberAttribution();
})();
